"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSaveBuildingAreaConfigMutation = exports.useReallocateBuildingAreasMutation = exports.useLazyFetchAvailableMetersQuery = exports.useLazyFetchAreaCandidatesQuery = exports.useFetchBuildingAreaConfigQuery = exports.buildingAreaConfigApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.buildingAreaConfigApi = (0, react_1.createApi)({
    reducerPath: "buildingAreaConfigApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["buildingAreaConfig"],
    endpoints: function (builder) { return ({
        fetchBuildingAreaConfig: builder.query({
            query: function (_a) {
                var clientId = _a.clientId, buildingId = _a.buildingId;
                return ({
                    url: "/v1/building-area-config/fetch",
                    method: "GET",
                    params: { clientId: clientId, buildingId: buildingId },
                });
            },
            providesTags: ["buildingAreaConfig"],
        }),
        fetchAreaCandidates: builder.query({
            query: function (_a) {
                var clientId = _a.clientId, buildingId = _a.buildingId, premiseId = _a.premiseId;
                return ({
                    url: "/v1/building-area-config/area-candidates",
                    method: "GET",
                    params: { clientId: clientId, buildingId: buildingId, premiseId: premiseId },
                });
            },
        }),
        fetchAvailableMeters: builder.query({
            query: function (_a) {
                var clientId = _a.clientId, buildingId = _a.buildingId, areaId = _a.areaId;
                return ({
                    url: "/v1/building-area-config/available-meters",
                    method: "GET",
                    params: __assign({ clientId: clientId, buildingId: buildingId }, (areaId ? { areaId: areaId } : {})),
                });
            },
        }),
        /*
         * §2(c) — the alternative for a premise whose area was just taken by another row.
         *
         * A mutation only because it POSTs the screen's unsaved allocation; it writes nothing, so it
         * deliberately invalidates no tags — re-fetching the configuration here would throw away every
         * unsaved pick on the screen, which is exactly what "live without needing to be saved" forbids.
         */
        reallocateBuildingAreas: builder.mutation({
            query: function (body) { return ({
                url: "/v1/building-area-config/reallocate",
                method: "POST",
                body: body,
            }); },
        }),
        saveBuildingAreaConfig: builder.mutation({
            query: function (body) { return ({
                url: "/v1/building-area-config/save",
                method: "POST",
                body: body,
            }); },
            invalidatesTags: ["buildingAreaConfig"],
        }),
    }); },
});
exports.useFetchBuildingAreaConfigQuery = exports.buildingAreaConfigApi.useFetchBuildingAreaConfigQuery, exports.useLazyFetchAreaCandidatesQuery = exports.buildingAreaConfigApi.useLazyFetchAreaCandidatesQuery, exports.useLazyFetchAvailableMetersQuery = exports.buildingAreaConfigApi.useLazyFetchAvailableMetersQuery, exports.useReallocateBuildingAreasMutation = exports.buildingAreaConfigApi.useReallocateBuildingAreasMutation, exports.useSaveBuildingAreaConfigMutation = exports.buildingAreaConfigApi.useSaveBuildingAreaConfigMutation;
